module.exports = __webpack_public_path__ + "img/map-prince-park.3ab0dc77.png";